import { useEffect, useState } from "react";
import Card from "./card";
import InfiniteScroll from "react-infinite-scroll-component";
import { useSelector, useDispatch } from "react-redux";
import { EMenuActions } from "../../store";
import ItemPreview from "./itemPreview";
import { CiGrid41 } from "react-icons/ci";
import { HiViewList } from "react-icons/hi";

export default function ItemsSection() {
  let dispatch = useDispatch();

  const products = useSelector((state) => state.EMenu.products);
  const loadProducts = useSelector((state) => state.EMenu.loadProducts);
  const previewItem = useSelector((state) => state.EMenu.previewItem);
  const menu_type = useSelector((state) => state.EMenu.menu_type);
  const cardViewType = useSelector((state) => state.EMenu.cardViewType);

  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [loading, setLoading] = useState(false);

  const fetchMoreData = () => {
    setTimeout(() => {
      const newProducts = [];
      if (products.length !== newProducts.length) {
        setHasMore(false);
      } else {
        setLoading(loading);
        setHasMore(hasMore);
        setPage(page + 1);
        dispatch(EMenuActions.setProducts([...newProducts]));
      }
      setLoading(false);
    }, 500);
  };

  const changeCardviewType = () => {
    dispatch(
      EMenuActions.setCardViewType(cardViewType === "grid" ? "list" : "grid")
    );
  };
  useEffect(() => {
    fetchMoreData();
  }, []);

  return (
    <>
      <section className="px-6 max-sm:px-3 mt-4">
        {products.length === 0 ? (
          <div className="text-center my-12 mx-24">
            {loadProducts ? (
              <p>Loading Menu...</p>
            ) : (
              <div className="w-[70%] max-sm:w-[100%] m-auto text-center">
                <p className="text-5xl mt-28 mb-5 font-light">
                  No product found
                </p>
                <span className="text-lg font-light">
                  We are dedicated to improving our services to provide you with
                  an even better experience.
                </span>
              </div>
            )}
          </div>
        ) : (
          <>
            <div className="flex flex-row items-center justify-between">
              <p className="text-lg m-1 uppercase tracking-wide font-extrabold text-dark">
                Select <span className="font-normal">{menu_type}</span>
              </p>
              <div
                onClick={changeCardviewType}
                className="bg-dark/10 p-1 border rounded-lg text-dark/50 border-dark/20"
              >
                {cardViewType === "list" ? (
                  <HiViewList size={20} />
                ) : (
                  <CiGrid41 size={20} />
                )}
              </div>
            </div>

            <div className="overflow-scroll h-[60vh]">
              <InfiniteScroll
                dataLength={products.length}
                next={fetchMoreData}
                hasMore={hasMore}
                loader={
                  <div className="bg-white border-2 border-light font-bold text-light text-center py-2 rounded-md">
                    Loading menu 🍛 ...
                  </div>
                }
                endMessage={
                  products.length === 0 ? (
                    <p style={{ textAlign: "center" }}>
                      <b>Searched meal not available 🫣</b>
                    </p>
                  ) : (
                    <p style={{ textAlign: "center" }}>
                      <b>Yay! You have seen it all 🎊</b>
                    </p>
                  )
                }
              >
                <ul
                  className={`${
                    cardViewType === "grid" &&
                    "grid max-sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 2xl:grid-cols-5"
                  } ${cardViewType === "list" && "flex flex-col"} gap-3 mb-5`}
                >
                  {products.map(
                    ({
                      SellPrice1,
                      SellPrice2,
                      SellPrice3,
                      SellPrice4,
                      SellPrice5,
                      SellPrice6,
                      SellUnit,
                      barcode,
                      cooktime,
                      description,
                      id,
                      productid,
                      image,
                      name,
                      subgroupid,
                      storePrice,
                    }) => (
                      <Card
                        key={id}
                        ProductId={productid}
                        image={image}
                        ProductName={name}
                        description={description}
                        Price={storePrice}
                        time={cooktime}
                      />
                    )
                  )}
                </ul>
              </InfiniteScroll>
            </div>
          </>
        )}
        {previewItem && <ItemPreview />}
      </section>
    </>
  );
}
